export enum ExceptionalRecognitionPaymentCategory {
  SignOnBonus = 'SignOnBonus',
  ExceptionalRecognition = 'ExceptionalRecognition',
  TransformationIncentive = 'TransformationIncentive'
}
